import {Component} from '@angular/core';
import {ExecutionService} from '../execution.service';

@Component({
    selector: 'mydocma-stepper-execution-step',
    templateUrl: './execution-step.component.html',
    styleUrls: ['./execution-step.component.scss']
})
export class ExecutionStepComponent {

    constructor(
        public readonly executionService: ExecutionService
    ) {
    }
}
